import { render, staticRenderFns } from "./CreateUserDataAddressModal.vue?vue&type=template&id=48cdca33&"
import script from "./CreateUserDataAddressModal.vue?vue&type=script&lang=js&"
export * from "./CreateUserDataAddressModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports